//
//
//
//
//
//
//
//


import { createNamespacedHelpers as vuexModule } from 'vuex';
import { COUNTERS_GET } from 'store/modules/moduleWebTracking/actionTypes';

const {
	mapActions,
	mapGetters
} = vuexModule('moduleWebTracking');

export default {
	computed: {
		...mapGetters([
			'isTrackingVerified'
		])
	},

	mounted() {
		this.COUNTERS_GET();
	},

	methods: {
		...mapActions([
			COUNTERS_GET
		])
	}
};

